import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-play" }, null, -1);
import { computed } from 'vue';
import { Button } from '@/components/UI';
import useMySchedule from '@/compositions/useMySchedule';
import useRooms from '@/compositions/useRooms';
export default /*#__PURE__*/ _defineComponent({
    props: {
        group: null,
        teamId: null
    },
    setup(__props) {
        const props = __props;
        const group = computed(() => props.group);
        const teamId = computed(() => props.teamId);
        const team = computed(() => { var _a; return (_a = group.value.teams[teamId.value]) !== null && _a !== void 0 ? _a : null; });
        const { currentRoomId, currentRoomName } = useMySchedule(group, teamId);
        const { setRFID } = useRooms();
        const scan = async () => {
            if (currentRoomId.value === null) {
                console.error('no next room selected');
                return;
            }
            if (team.value === null) {
                console.error('no team selected');
                return;
            }
            const rfid = team.value.members.map(member => member.rfid).find(rfid => rfid !== null);
            if (rfid === undefined) {
                console.error('no rfid found');
                return;
            }
            await setRFID({ roomid: currentRoomId.value, rfid: 'start', value: rfid });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Button), {
                variant: "success",
                disabled: !_unref(currentRoomId),
                title: _unref(currentRoomName),
                onClick: scan
            }, {
                default: _withCtx(() => [
                    _hoisted_1,
                    _createTextVNode(" " + _toDisplayString(_unref(currentRoomId)), 1)
                ]),
                _: 1
            }, 8, ["disabled", "title"]));
        };
    }
});
